import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { MerchCardBadge } from 'pricing-pages-ui-components/badges/MerchCardBadge';
import { jsx as _jsx } from "react/jsx-runtime";
export const CurrentTrialBadge = ({
  message = 'pricing-pages-ui.merchCardsV2.badges.CURRENT_TRIAL'
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  if (isTrellis) {
    return /*#__PURE__*/_jsx(MerchCardBadge, {
      translationKey: message,
      badgeColor: "specialty-tertiary-on-fill-default"
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "0",
    insetInlineStart: "0",
    children: /*#__PURE__*/_jsx(Tag, {
      use: "default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    })
  });
};